import { Quote } from "lucide-react";

/**
 * Corporate / Association testimonials — REAL verified quotes
 * from documented letters on company letterhead (on file).
 */
const corporate = [
  {
    quote:
      "What an INCREDIBLE presentation! The feedback from the staff has been extremely positive. Every person who attended walked out with a feeling that the time was well spent. My only regret is that we didn't allow for more time.",
    name: "Robin K. Graf",
    org: "Executive Assistant Manager — Hilton Waikoloa Village",
  },
  {
    quote:
      "Your enthusiastic program offered our attendees both a professional and personal perspective on today's ever-changing and demanding world. Your ability to customize the speech to our specific goals and objectives helped to motivate our audience.",
    name: "Adrienne Chambers",
    org: "MasterCard International — New Markets Acquirer Forum",
  },
  {
    quote:
      "Besides Gary being entertaining, he easily conveyed our vision of teams working together — focusing, asking questions, and leading to create passion for our jobs.",
    name: "Brenda C. Wolf",
    org: "Director, Supplier Management — Boeing C-130 AMP Supplier Conference",
  },
  {
    quote:
      "You touched the hearts, souls and minds of everyone in the room each night. Gary, you are truly a professional to work with. I have never asked a speaker to return the following year but your message was special enough that I would like to have you come back.",
    name: "Mark R. Gensheimer",
    org: "Executive Vice President — Federated Securities Corp.",
  },
  {
    quote:
      "Gary was able to customize our program, geared to sales and marketing, while giving it a personal touch. His FAMILY tips applied equally well to our business goals in today's competitive marketplace. The Z-Man will be invited to future meetings. We like his attitude.",
    name: "Jeanne E. Miller",
    org: "Senior Vice President — Bay View Bank Auto Finance Group",
  },
  {
    quote:
      "Your combination of relative information and inspirational humor was the key to the success of the seminar. After the presentation, several Representatives came to me expressing their appreciation and how your message really touched them.",
    name: "Diane Carrier",
    org: "President & CEO — ExcellaDerm Corporation",
  },
  {
    quote:
      "Your presentation 'Life on the Ledge: The Power of Teamwork' was both engaging and motivating, and greatly contributed to the overall success of the meeting.",
    name: "John Truitt",
    org: "President-Elect — Electrical Equipment Representatives Association (EERA)",
  },
  {
    quote:
      "Your energy is very contagious. Our group loves to laugh and learn. After you spoke, we all felt energized, inspired, and we left smiling.",
    name: "Darrell W. Cain",
    org: "Cain Watters & Associates, P.C. — Dallas",
  },
  {
    quote:
      "Your message was enthusiastic, meaningful, applicable, and extremely well received. One respondent even singled you out: 'Gary was fantastic!' Thank you for making our conference one of the best ever.",
    name: "Art Dinkin, CFP, CLU, ChFC, LUTCF",
    org: "Central Financial Group / AmerUs Life — Iowa Assoc. of Insurance & Financial Advisors",
  },
];

const clientLogos = [
  "Hilton Waikoloa", "MasterCard", "Boeing", "Hyatt", "Hallmark", "Gulfstream",
  "Federated Securities", "Bay View Bank", "ExcellaDerm", "EERA",
  "Cain Watters", "AmerUs Life",
];

export default function CorporateTestimonials() {
  return (
    <section
      id="corporate-testimonials"
      data-testid="corporate-testimonials-section"
      className="bg-[#050505] py-24 md:py-32 border-t border-[#262626]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">CORPORATE & ASSOCIATIONS</span>
          <div className="divider-red" />
        </div>
        <h2 className="h-display text-5xl md:text-6xl lg:text-7xl max-w-4xl">
          Beyond dental.<br />
          Trusted by <span className="text-[#EC1985]">global brands.</span>
        </h2>
        <p className="mt-6 text-white/70 text-lg max-w-2xl">
          Gary has delivered keynotes for Fortune 500 corporate audiences,
          hospitality leaders, financial services teams, and associations across
          the U.S. and abroad.
        </p>

        {/* Client logos as text bricks */}
        <div className="mt-10 flex flex-wrap gap-3">
          {clientLogos.map((c) => (
            <span
              key={c}
              className="text-sm uppercase tracking-[0.2em] font-bold border border-[#262626] bg-[#0a0a0a] px-4 py-3 text-white/90"
            >
              {c}
            </span>
          ))}
        </div>

        {/* Corporate quote cards */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {corporate.map((c, i) => (
            <article
              key={i}
              data-testid={`corporate-testimonial-${i}`}
              className="surface p-7 hover:border-[#EC1985] transition-colors flex flex-col"
            >
              <Quote size={28} className="text-[#EC1985] mb-5" />
              <p className="text-white/90 text-base leading-relaxed flex-1">
                "{c.quote}"
              </p>
              <div className="mt-6 pt-5 border-t border-[#262626]">
                <div className="text-sm font-bold text-white">{c.name}</div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/60 mt-1 leading-snug">
                  {c.org}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 text-xs uppercase tracking-[0.2em] text-white/40 font-bold">
          ★ All quotes verified from original letters on company letterhead — references on file
        </div>
      </div>
    </section>
  );
}
